import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';

import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ActionModal from 'components/Modal/ActionModal';
import { toast } from 'components/global/CUK/Toast/Toast';
import { trackEvent } from 'analytics';

import {
  OPERATION_REBOOT_DEVICE,
} from '../operations-gql';
import { Room, useRoom } from '../use-rooms';

const RebootModal = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { deviceId } = useParams();
  const room: Room | undefined = useRoom()
  
  const [reboot, { loading }] = useMutation(OPERATION_REBOOT_DEVICE, {
    variables: {
      sf_id: room?.site_sf_id,
      device_uuid: deviceId,
    },
    onCompleted: () => {
      trackEvent('stream_cast_device_rebooted');
      toast.success(t('stream-cast.actions.reboot.toast_success'));
      navigate(`..${location.search}`);
    },
    onError: () => {
      trackEvent('stream_cast_action_failed', { action: 'reboot' });
      toast.error(t('stream-cast.actions.reboot.toast_error'));
      navigate(`..${location.search}`);
    },
  });

  return (
    <ActionModal
      cancelLabel={t('ui_elements.cancel')}
      confirmColor="primary"
      confirmLabel={t('ui_elements.confirm')}
      description={t('stream-cast.actions.reboot.modal.body')}
      icon={<i className="fa-solid fa-arrow-rotate-left" />}
      loading={loading}
      onClose={() => navigate(`..${location.search}`)}
      onConfirm={() => reboot()}
      title={t('stream-cast.actions.reboot.modal.title')}
      variant="primary"
    />
  );
};

export default RebootModal;
